import {NgModule} from '@angular/core';
import {TextOverflowDirective} from "./text-overflow.directive";

@NgModule({
    declarations: [
        TextOverflowDirective,
    ],
    exports: [
        TextOverflowDirective,
    ],
})
export class TextOverflowModule {}
